var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocStack = function SvgDocStack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "doc_stack_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".doc_stack_svg__docStack0{fill:#1d1d1b}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M882.5 166.2 725.2 8.9c-5.8-5.8-13.7-9.1-21.9-9.1H321.9C304.8-.2 291 13.6 291 30.7v765.6c0 17.1 13.8 30.9 30.9 30.9h538.7c17.1 0 30.9-13.8 30.9-30.9V188.1c.1-8.2-3.2-16.1-9-21.9M738.2 91.8l60.2 60.6h-60.2zm103.5 685.7H340.8V49.7H688v113c0 21.8 17.7 39.5 39.5 39.5h114.3v575.3z",
    className: "doc_stack_svg__docStack0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431 172h110.8c10 0 18-6.6 18-14.8v-11.3c0-8.2-8.1-14.8-18-14.8H431c-10 0-18 6.6-18 14.8v11.3c0 8.2 8.1 14.8 18 14.8M595.2 203.2H431c-10 0-18 6.6-18 14.8v11.3c0 8.2 8.1 14.8 18 14.8h164.1c10 0 18-6.6 18-14.8V218c.1-8.1-8-14.8-17.9-14.8M249.5 86.4h-18.9c-17.1 0-30.9 13.8-30.9 30.9V883c0 17.1 13.8 30.9 30.9 30.9h538.7c17.1 0 30.9-13.8 30.9-30.9v-19H249.5z",
    className: "doc_stack_svg__docStack0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.3 172.6h-18.9c-17.1 0-30.9 13.8-30.9 30.9v765.6c0 17.1 13.8 30.9 30.9 30.9h538.7c17.1 0 30.9-13.8 30.9-30.9v-18.9H158.3z",
    className: "doc_stack_svg__docStack0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocStack);
export default ForwardRef;